import React from 'react';

import { Radio } from './styled';

function RadioComponent({
  iconSize = '24px',
  ...props
}) {
  return (
    <Radio
      {...props}
      type="radio"
      iconSize={iconSize}
    />
  );
}

export default RadioComponent;
